import { Component, AfterViewInit, AfterViewChecked, NgZone, ViewChild, ChangeDetectorRef, } from '@angular/core';
import { NgForm } from '@angular/forms';
import { Router, ActivatedRoute } from '@angular/router';
import { Title } from '@angular/platform-browser';
import { Subscription } from 'rxjs/Subscription';

import { TdLoadingService, TdMediaService, TdDialogService, } from '@covalent/core';

import { Diagnostico } from '../../../../../models/';

import { MasterService, LoginService, DiagnosticosService, } from '../../../../../services/';

@Component({
  selector: 'qs-altadiagnosticos',
  templateUrl: './altadiagnostico.component.html',
  styles: ['./altadiagnostico.component.scss'],
  viewProviders: [DiagnosticosService],
})

export class AltaDiagnosticoComponent implements AfterViewInit, AfterViewChecked {

  private idPaciente: string;
  public diagnostico: any;
  public diagnosticoForm: NgForm;

  constructor(private _loadingService: TdLoadingService,
    public media: TdMediaService,
    private _loginService: LoginService,
    private _ngZone: NgZone,
    private _router: Router,
    private _route: ActivatedRoute,
    private _dialogService: TdDialogService,
    private _changeDetectorRef: ChangeDetectorRef,
    private _diagnosticosService: DiagnosticosService, ) {

  }

  ngAfterViewInit(): void {
    this.media.broadcast();
    this.idPaciente = this._loginService.consulta.numeroExpediente;
    this._loadingService.register('diagnostico.load');
    this._changeDetectorRef.detectChanges();
  }

  /**
   * FIX: Esto es un fix para ExpressionChangedAfterItHasBeenCheckedError
   * Aparece al cargar un componente de la vista con datos desde un servicio
   */
  ngAfterViewChecked(): void {
    this._changeDetectorRef.detectChanges();
  }

  save(form: NgForm): void {
    this._loadingService.register();
  // TODO: Modificar el objeto por el esperado
    let diagnostico: any = {
      dniMedico: this._loginService.profesional.Dni,
      numeroExpediente: this._loginService.consulta.numeroExpediente,
      visita: this._loginService.consulta.visita,
      cip: this._loginService.consulta.cip,
      cias: '',
    };
    /*
    this._diagnosticosService.altaDiagnostico({ request: { diagnostico: diagnostico } }).subscribe((res) => {
      if (res) {
        this._loginService.mostrarMensaje("Técnicas Diagnóstica Añadida", "OK", 6000);
        this._loadingService.resolve();
        this.close();
        this._router.navigate(['/main/consulta/', this._loginService.consulta.numeroExpediente, 'tecnicasdiagnosticas'], { relativeTo: this._route });
      } else {
        this._loginService.mostrarMensaje("Error al insertar Técnicas Diagnóstica", "OK", 6000);
        this._loadingService.resolve();
      }
    });
    */
  }

  close(): void {
    this._dialogService.closeAll();
  }

}



// WEBPACK FOOTER //
// ./src/app/consulta/diagnosticos/diagnosticosdetalle/altadiagnostico/altadiagnostico.component.ts